export default __webpack_public_path__ + "static/kitchenji-6810b8839198ccf79243af3a1f56b058.jpg";